export enum WatchlistActionType {
    WatchlistEntryDetails = 0,
    LoanDetails = 1,
    WatchlistEditGroup = 2,
    LoanAuditHistory = 3,
}
